/**
 * Defines the arc radius threshold in client-side SVG generation beyond which the arc segment will be approximated by a straight line.
 */
export const MAX_ARC_RADIUS = 1e6
export const POINT_COMPARISON_PRECISION = 0.0001
